import { render } from "./ProfileLangAlternative.vue?vue&type=template&id=b89f6c7a"
import script from "./ProfileLangAlternative.vue?vue&type=script&lang=js"
export * from "./ProfileLangAlternative.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/wp-content/themes/w2w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__